import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectRoadTypesState } from '../selectors';

export const getData = createSelector(selectRoadTypesState, (state: State) => state.data);

export const getError = createSelector(selectRoadTypesState, (state: State) => state.error);

export const getLoading = createSelector(selectRoadTypesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectRoadTypesState, (state: State) => fn(state.data));
